import React from 'react';
import { formatPrice, formatPriceNumber } from 'utils/utils';
import { css } from '@emotion/react';
import { theme } from 'styles/theme';
import { usePrice } from 'hooks/usePrice';

export const PrefilledValuePrice = ({ price, isVAT, showVATCalculation }) => {
	const { withoutVAT, withVAT, VAT } = usePrice({ price: price });

	return (
		<div>
			<span
				css={css`
					color: ${theme.color.text['300']};
				`}
			>
				<strong>
					{formatPriceNumber(isVAT ? withVAT : withoutVAT)} <strong>CZK</strong>
				</strong>
				{isVAT ? ' s DPH' : ''}
			</span>
			{isVAT && showVATCalculation && (
				<>
					<div
						css={css`
							font-size: 13px;
							color: ${theme.color.text['300']};
						`}
					>
						<strong>Bez DPH:</strong> {formatPrice(withoutVAT)}
					</div>

					<div
						css={css`
							font-size: 13px;
							color: ${theme.color.text['300']};
						`}
					>
						<strong>DPH:</strong> {formatPrice(VAT)}
					</div>
				</>
			)}
		</div>
	);
};
